import {Translation} from "../type";

export const findTranslationByCode = (code: string, translations: Translation[]) => {
	const translationObj = translations.find((t) => t.code === code);
	return translationObj ? translationObj.translation.toUpperCase() : code;
};
